// 洞洞杂货铺 · 角色图鉴数据
export interface Character {
  id: string;
  name: string;
  role: string;
  tagline: string;
  desc: string;
  trait: string;
  accent: "primary" | "accent" | "secondary";
  image: string;
}

export const characters: Character[] = [
  {
    id: "shopkeeper",
    name: "店主「阿洞」",
    role: "杂货铺主人",
    tagline: "会倾听所有洞洞低语的人",
    desc: "穿着沾了茶渍围裙的年轻店主，永远挂着温和的笑。他能听见墙洞里传来的各种声响，并把它们整理成货架上的每一件小物。没人知道他的年龄，也没人知道他最初是怎么走进这家店的。",
    trait: "「洞」的倾听者",
    accent: "primary",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20illustrated%20portrait%20of%20a%20gentle%20young%20grocery%20store%20shopkeeper%20with%20an%20apron%20and%20soft%20smile%2C%20amber%20cream%20palette%2C%20storybook%20fantasy%20style%2C%20cozy%20warm%20lighting%2C%20hand%20drawn&width=640&height=800&seq=char-shopkeeper-1&orientation=portrait",
  },
  {
    id: "hole-cat",
    name: "洞洞猫",
    role: "店铺镇店之宠",
    tagline: "总在洞口边打盹的守门者",
    desc: "一只毛色像旧棉被的胖橘猫，喜欢趴在最大的那个洞口边睡午觉。据说只有它看得见洞的另一边到底通向哪里。当它突然竖起耳朵，往往意味着新的客人要来了。",
    trait: "「洞」的守门者",
    accent: "accent",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20illustrated%20portrait%20of%20a%20chubby%20orange%20tabby%20cat%20curled%20up%20beside%20a%20glowing%20magical%20hole%2C%20cozy%20amber%20and%20cream%20palette%2C%20storybook%20chibi%20style%2C%20hand%20drawn%20cute%20fantasy&width=640&height=800&seq=char-cat-2&orientation=portrait",
  },
  {
    id: "night-mare",
    name: "失眠人「小夜」",
    role: "夜班常客",
    tagline: "总在打烊后才来买一杯热牛奶",
    desc: "因为总失眠而成为深夜杂货铺的常客。她每次只买一杯热牛奶，却在货架边一待就是很久。她似乎知道某个洞洞通向的地方，正是自己反复做噩梦的源头。",
    trait: "「洞」的旅人",
    accent: "secondary",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20illustrated%20portrait%20of%20a%20sleepy%20young%20woman%20holding%20a%20cup%20of%20warm%20milk%20in%20a%20cozy%20night%20grocery%20store%2C%20soft%20amber%20lighting%2C%20cream%20palette%2C%20storybook%20style%2C%20hand%20drawn%20mild%20melancholy&width=640&height=800&seq=char-night-3&orientation=portrait",
  },
  {
    id: "bird-brother",
    name: "邮差「鸽子先生」",
    role: "送信人",
    tagline: "穿梭于洞与洞之间的信使",
    desc: "永远穿着制服、随身带着一个塞满信封的斜挎包的鸽子先生。他能带着信穿过最小的洞洞，把消息从一个世界送到另一个世界。没人知道他是怎么认路的。",
    trait: "「洞」的邮差",
    accent: "accent",
    image:
      "https://readdy.ai/api/search-image?query=Warm%20illustrated%20portrait%20of%20a%20gentle%20pigeon%20mailman%20in%20uniform%20with%20a%20satchel%20of%20letters%2C%20cozy%20amber%20and%20teal%20palette%2C%20storybook%20fantasy%20style%2C%20hand%20drawn%20warm%20friendly&width=640&height=800&seq=char-bird-4&orientation=portrait",
  },
];